import { AppLayout } from "../shared";
import Advertisement from "../Advertisement/advertisement";

const Advertisement_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <Advertisement props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default Advertisement_layout;
